<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="value"
                append-icon="mdi-calendar"
                readonly
                v-bind="{...attrs, ...$attrs}"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker :value="value" @input="onInput"></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    props: {
        value: String
    },
    data() {
        return {
            menu: false
        }
    },
    methods: {
        onInput(e) {
            this.$emit("change", e)
            this.menu = false;
            this.$emit('input', e)
        }
    }
};
</script>

<style>
</style>